import {useAuthUserStore} from "@/stores/auth";

export default {
    /*
     * Normaliza una URL de YouTube o Vimeo (LMS-083). Devuelve
     * { provider, id, embed_url }; una URL no soportada responde 422.
     */
    resolve(url) {
        return useAuthUserStore().getApiClient.post('/v2/videos/embeds/resolve', {url})
    },
}
